"use client";

import { useContext, useEffect, useState } from "react";

import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContext } from "@/contexts/QREditorContext";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";

import { applyQRFormDefaultValues, onBindClick } from "@/utils/formHelper";
import { omittedValues, onBindSocialNetworks, onBindThemePicker } from "@/utils/qrEditorHelper";
import { qrSocialValidation } from "@/utils/validators/qr-social";

import { FileProps } from "@/components/FilesUpload/types";
import { QRSocialProps } from "./types";
import { useTranslation } from "react-i18next";
import { NAMESPACES } from "@/internals/constants/namespaces";

import "./styles.scss";

export function QRSocial({ data }: QRSocialProps) {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = useContext<QREditorContextProps<"social">>(QREditorContext);

  const [qrSocialData, setQrSocialData] = useState<QRProps<"social">>(qrData);
  const [renderForm, setRenderForm] = useState(false);

  const dataSocialWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);
  const onUpdateState = ({ field, value }) => {
    if (field === "file" || field == "") return;
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          [field]: value,
        },
      },
      [...omittedValues(qrData.data)]
    );
  };

  onBindClick(dataSocialWithDefaultValues, "qrSocialUploadImage", (socialUrl: FileProps[]) => {
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          logoUrl: socialUrl[0]?.url as string,
        },
      },
      [...omittedValues(qrData.data)]
    );
  });

  onBindThemePicker(dataSocialWithDefaultValues, "qrSocialThemePicker", [
    ...omittedValues(qrData.data),
  ]);

  onBindSocialNetworks(
    dataSocialWithDefaultValues,
    "qrSocialSocials",
    "links",
    [...omittedValues(qrData.data)],
    false,
    qrSocialData
  );

  useEffect(() => {
    setQrSocialData(qrData);
  }, [qrData]);

  useEffect(() => {
    setQrData({ ...qrSocialData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-social">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataSocialWithDefaultValues}
        schema={qrSocialValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => {
          setRenderForm(isValidForm);
        }}
      />
    </div>
  );
}
